/**
 * Onboarding progress flags — tiny localStorage-backed step tracker for the
 * role-aware "Getting started" runway (GettingStartedCard).
 *
 * Two kinds of step completion exist:
 *   • data-detected  — derived live from real state (companies.length, AGM set)
 *   • visit-flagged  — marked when the user actually reaches a surface
 *     (markOnboardingStep('visited-alerts') in that page's mount effect)
 *
 * Flags are additive and never unset — onboarding only moves forward.
 * A window event keeps any mounted card in sync without a re-render library.
 */
const FLAGS_KEY = 'cs-onboarding-flags';
const EVENT = 'cs-onboarding-change';

export function getOnboardingFlags() {
  try {
    return JSON.parse(localStorage.getItem(FLAGS_KEY) || '{}') || {};
  } catch {
    return {};
  }
}

export function markOnboardingStep(id) {
  try {
    const flags = getOnboardingFlags();
    if (flags[id]) return; // already done — no churn, no event spam
    flags[id] = true;
    localStorage.setItem(FLAGS_KEY, JSON.stringify(flags));
    window.dispatchEvent(new Event(EVENT));
  } catch {
    /* storage unavailable — onboarding quietly degrades */
  }
}

export function onOnboardingChange(handler) {
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}

/* Per-role dismissal of the Getting Started card. */
export function isOnboardingDismissed(role) {
  try {
    return localStorage.getItem(`cs-onboarding-dismissed-${role}`) === '1';
  } catch {
    return false;
  }
}

export function dismissOnboarding(role) {
  try {
    localStorage.setItem(`cs-onboarding-dismissed-${role}`, '1');
  } catch {
    /* ignore */
  }
}
